<template>
    <div style="margin: 10px">
        <v-card>
            <v-toolbar color="primary" dark v-if="!print">
                <v-toolbar-title>{{$t(formName)}}</v-toolbar-title>
            </v-toolbar>
            <form v-if="!print">
                <v-layout wrap>
                    <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                        <v-autocomplete :label="$t('lang.area.name')"
                                  v-model.trim="search.areaId"
                                  v-validate="'required'"
                                  :items="lstArea"
                                  item-text="categoryName"
                                  item-value="categoryId"
                                  @change=""
                                  clearable
                        />
                    </v-flex>
                    <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                        <v-autocomplete :label="$t('lang.material.materialType')"
                                  v-model.trim="search.typeId"
                                  :items="lstMaterialType"
                                  item-text="categoryName"
                                  item-value="categoryId"
                                  @change=""
                                  clearable
                        />
                    </v-flex>
                  <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 10px">
                    <v-autocomplete :label="$t('lang.report.type')"
                              v-model.trim="reportTypeId"
                              :items="lstReportType"
                              item-text="reportTypeName"
                              item-value="reportTypeId"
                              @change=""
                              clearable
                    />
                  </v-flex>

                </v-layout>
                <v-layout wrap>
                    <v-flex xs12 sm12 md6 lg6 xl6 style="padding: 10px">
                        <i-datepicker :label="$t('lang.common.fromDate')"
                                      v-model="search.fromDate"
                                      v-validate="'date_before_now'"
                                      :data-vv-as="$t('lang.common.fromDate')"
                                      name="fromDate"
                                      :maxDate="maxDay()"
                                      :error-messages="errors.first('fromDate')"
                        />
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6 xl6 style="padding: 10px">
                        <i-datepicker
                                :label="$t('lang.common.toDate')"
                                v-model="search.toDate"
                                v-validate="'date_before_now|endDateAfterStart'"
                                :data-vv-as="$t('lang.common.toDate')"
                                name="toDate"
                                :maxDate="maxDay()"
                                :error-messages="errors.first('toDate')"
                        />
                    </v-flex>
                </v-layout>
            </form>
            <table v-else class="infomation infoTable">
                <tr>
                    <td colspan="2" style="text-align: center;width: 100%" class="title">BÁO CÁO SỬ DỤNG VẬT TƯ</td>
                </tr>
                <tr>
                    <td><label>Từ ngày:</label> {{search.fromDate | formatDate}}</td>
                    <td><label>Đến ngày:</label> {{search.toDate | formatDate}}</td>
                </tr>
            </table>

            <v-card-actions>
                <v-spacer/>
                <v-btn color="primary" @click="onPrint">
                    {{ $t("lang.report.print") }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <send-report ref="sendDlg" @send="onSendTo"/>
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "../../shared/message";
    import moment from "moment";
    import MaterialReportItem from "./MaterialReportItem";
    import MaterialReportSummary from "./MaterialReportSummary";
    import SendReport from "./SendReport";
    import {Validator} from "vee-validate";

    export default {
        name: "material-report",
        components: {SendReport, MaterialReportSummary, MaterialReportItem},
        data: () => {
            return {
                formName: "Báo cáo sử dụng vật tư",
                lstMaterialType: [{"categoryId":-1, "categoryName":"Tất cả"}],
                lstReportType:[{reportTypeId:1, reportTypeName:"Báo cáo xuất kho"},
                  {reportTypeId:2, reportTypeName:"Báo cáo Nhập kho"}],
                reportTypeId: 1,
                lstArea: [{"categoryId":-1, "categoryName":"Tất cả"}],
                lstCrop: [],
                cropSelected:[],
                lstItem: [],
                search: {
                    fromDate: (new Date()).setDate(new Date().getDate() - 7),
                    toDate: new Date(),
                    areaIdList: '',
                    typeIdList: '',
                },
                print:false,
                g: null,
                reportData:{},
                saveSession:new Date().getTime(),
            };
        },

        mounted(){
            Validator.extend("endDateAfterStart", {
                validate: (value, {otherValue}) => {
                    let mm = moment(value).hour(23).minute(59).second(59);
                    let valid = mm.isSameOrAfter(this.search.fromDate); // false
                    return {
                        valid: valid,
                        data: {
                            message: "Đến ngày phải sau Từ ngày"
                        }
                    };
                    ;
                },
                getMessage: (field, params, data) => {
                    return "Đến ngày phải sau Từ ngày";
                }
            });
        },

        created() {
            this.getArea();
            this.getMaterialType()
        },

        methods: {
            maxDay(){
                let day = moment().format("YYYY-MM-DD");
                console.log(day);
                return day;
            },



            getArea() {
                axios.post(
                    process.env.VUE_APP_API_URL + "/category/myArea"
                ).then(
                    (data) => {
                        if (data.length > 0) {
                            this.lstArea.push(...data);
                        }
                    }
                );
            },



          getMaterialType() {
            let url = process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE";
            axios.post(url).then(
                (data) => {
                  if (data.length > 0) {
                    this.lstMaterialType.push(...data);
                  }
                }
            );
          },


            onPrint() {
              if(this.reportTypeId == 1){
                axios({
                  url: process.env.VUE_APP_API_URL + "/exportMatReqReportView/exportExcel",
                  method: "POST",
                  data: this.search,
                  responseType: "blob", // important
                }).then(response => {
                  if (response) {
                    const url = window.URL.createObjectURL(new Blob([response]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "Baocao_xuat_vatu" + ".xlsx");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                  }
                });
              } else if(this.reportTypeId == 2){
                axios({
                  url: process.env.VUE_APP_API_URL + "/importMatReqReportView/exportExcel",
                  method: "POST",
                  data: this.search,
                  responseType: "blob", // important
                }).then(response => {
                  if (response) {
                    const url = window.URL.createObjectURL(new Blob([response]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "Baocao_nhap_vatu" + ".xlsx");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                  }
                });
              }

            },

            onSendTo(user) {
                console.log('--- send to user');
                console.log(user);
                let url =process.env.VUE_APP_FRONTEND_URL+"/#"+ this.generateReportURL();
                let report = {
                    reportType:'Báo cáo tình trạng ao',
                    userId:user.userId,
                    url:url
                };
                axios.post(process.env.VUE_APP_API_URL+"/report/sendReport",report).then(
                    data=>{
                        if(data.success){
                            message.success("Gửi thành công");
                            this.$refs.sendDlg.onCancel();
                        } else {
                            message.error("Gửi không thành công");
                        }
                    }
                );
            },
        },

        destroyed() {
        },
    };
</script>